import props from "./../../../src-utils/propDefiner";

export default {
  ...props("name", String, "pm-icon"),
};
